import { Injectable, Signal } from '@angular/core';
import { GearService, GearType } from '@softapps/werkstatt/garage-core';

@Injectable()
export abstract class CustomGearService<T> extends GearService<T> {
  abstract readonly type: Signal<GearType>;
  abstract readonly title: Signal<string>;
}
